import { useTranslation } from 'react-i18next';
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { asset } from './asset';

function Footer({
  children,
  links = [
    { labelKey: 'footer.links.linkedin', href: '#', icon: FaLinkedin, target: '_blank' },
    { label: 'Instagram', href: '#', icon: FaInstagram, target: '_blank' },
    { label: 'YouTube', href: '#', icon: FaYoutube, target: '_blank' },
    { label: 'Facebook', href: '#', icon: FaFacebook, target: '_blank' },
  ],
  copyright,
}) {
  const { t } = useTranslation();
  const resolvedCopyright = copyright || t('footer.copyright', { year: new Date().getFullYear() });

  return (
    <footer className="bg-black text-white mx-auto w-full sm:max-w-[80%] max-w-[90%] px-6 py-8 sm:px-8 lg:px-12">
      <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
        <Link to="/#home" aria-label="Go to top" className="block">
          <img src={asset('Poultri-logo.png')} alt="PoultriQ by AAZIRA" className="h-12 w-auto object-contain" />
        </Link>

        <nav className="flex flex-wrap items-center gap-x-1 gap-y-3" aria-label="Footer social links">
          {links.map((link) => {
            const label = link.labelKey ? t(link.labelKey) : link.label;
            return (
              <a
                key={label}
                href={link.href}
                className="inline-flex items-center gap-2 rounded border border-white/15 px-3 py-2 text-white/80 transition hover:border-white/30 hover:text-white"
                rel={link.href.startsWith('http') ? 'noreferrer' : undefined}
                target={link.target || (link.href.startsWith('http') ? '_blank' : undefined)}
                aria-label={label}
                title={label}
              >
                {link.icon ? <link.icon className="h-5 w-5" /> : null}
              </a>
            );
          })}
        </nav>
      </div>

      {children ? <p className="mt-7 text-sm font-semibold text-white/80">{children}</p> : null}

      <div className="mt-1 border-t border-white/15 pt-6 text-center text-xs font-semibold text-white/70">
        {resolvedCopyright}
      </div>
    </footer>
  );
}

export default Footer;

